export default {
  path: '/sims/sim-provider',
  name: 'SimProviders',
  component: () => import(/* webpackChunkName: "base" */ '../views/SimProvidersView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
